import React from 'react'
import Auth from '../component/Auth'
import { useEffect,useState } from 'react';
import {ToastContainer, toast } from 'react-toastify'; 
import Web3 from 'web3';
import QrReader from 'react-qr-reader';

function TokenTransaction() {
    const loginToken = localStorage.getItem('token');
    const [otpText, setOtpText] = useState('Request OTP');
    const[inputOtp, setInputOtp] = useState('');
    const [countdown, setCountdown] = useState(0);
    const [showLoading, setShowLoading] = useState(false);
    const [statusData, setStatsuData] = useState();
    const [tokenAvlAmount, setTokenAvlAmount] = useState(0)
    const [tokens, setTokens] = useState([]); // Store token options
    const [selectedToken, setSelectedToken] = useState("BNB"); // Default token
    const [amount, setAmount] = useState(""); // Amount input
    const [address, setAddress] = useState(""); // Wallet address or QR input
    const [history, setHistory] = useState([]); // Token history
    const [bnbBalance, setBnbBalance] = useState(0);
    const [kcoinBalance, setKcoinBalance] = useState(0);
    const [kaymcoinBalance, setKaymcoinBalance] = useState(0);
    const [usdtBalance, setUsdtBalance] = useState(0);
    const account = localStorage.getItem('userWallet');
    const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed.binance.org/");
    const kcoinTokenAddress = process.env.REACT_APP_KCOIN_TOKEN_ADDRESS;
    const kcoinAbi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];
    
    const kaymcoinAddress =  process.env.REACT_APP_KAYM_TOKEN_ADDRESS;
    const kaymcoinAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
    
    const usdtTokenAddress =  process.env.REACT_APP_USDT_TOKEN_ADDRESS;
    const usdttAbi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
   const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;

    // Fetch token options from an API when the component mounts
    useEffect(() => {
        

       getBnbBalance(account);
    }, []);

    // Handle token selection
    const handleTokenChange = (e) => {
        console.log(devAddress);

        setSelectedToken(e.target.value);
        const selectedToken =e.target.value;
        if(selectedToken === 'BNB'){
            console.log('BNB Balance');
            getBnbBalance(account);
        }else{

            if(selectedToken === 'USDT'){
                getTokenBalance(usdtTokenAddress, account, usdttAbi, setTokenAvlAmount);
            }

            if(selectedToken === 'KAYM'){
                getTokenBalance(kaymcoinAddress, account, kaymcoinAbi, setTokenAvlAmount);
            }
            if(selectedToken === 'KCOIN'){
                getTokenBalance(kcoinTokenAddress, account, kcoinAbi, setTokenAvlAmount);
            }
        }
    };




    const getBnbBalance = async (account) => {
        try {
            const balance = await web3.eth.getBalance(account);
            setTokenAvlAmount(web3.utils.fromWei(balance, 'ether'));
        } catch (error) {
            console.error('Error fetching BNB balance:', error);
        }
    }

    const getTokenBalance = async (tokenAddress, account, tokenABI, setBalance) => {
        try {
            const contract = new web3.eth.Contract(tokenABI, tokenAddress);
            const balance = await contract.methods.balanceOf(account).call();
            setBalance(web3.utils.fromWei(balance, 'ether'));
        } catch (error) {
            console.error(`Error fetching token balance for ${tokenAddress}:`, error);
        }
    }


    // Handle form submission (token transfer)
   


    const handleTransfer = async () => {
        // Validate inputs
        if (!inputOtp || inputOtp.trim() === '') {
            toast.error('Enter OTP');
            return;
        }
    
        if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
            toast.error('Enter a valid amount');
            return;
        }
    
        if (!selectedToken || selectedToken.trim() === '') {
            toast.error('Select a token');
            return;
        }
    
        if (!address || address.trim() === '') {
            toast.error('Enter a valid address');
            return;
        }
    
        setShowLoading(true);
    
        try {
            // Verify OTP
            const otpStatus = await verifyOtp(inputOtp);
            if (!otpStatus) {
                toast.error('OTP verification failed');
                return;
            }
    
            // Start transaction
            await startDevTxn();
    
            // Log transaction details
            console.log(`Transferring ${amount} ${selectedToken} to ${address}`);
    
            // Process token transfer based on the selected token type
            if (selectedToken === 'BNB') {
                await sendBNB(address, amount);
            } else if (selectedToken === 'USDT') {
                await sendToken(usdtTokenAddress, address, amount, usdttAbi, 'USDT');
            } else if (selectedToken === 'KAYM') {
                await sendToken(kaymcoinAddress, address, amount, kaymcoinAbi, 'KAYM');
            } else if (selectedToken === 'KCOIN') {
                await sendToken(kcoinTokenAddress, address, amount, kcoinAbi, 'KCOIN');
            } else {
                toast.error('Invalid token selected');
                return;
            }
    
        } catch (error) {
            console.error("Transfer failed:", error);
            toast.error("Transfer failed. Please try again.");
        } finally {
            setShowLoading(false);
        }
    };
    


    const sendBNB = async (toAddress, amount) => {
        setShowLoading(true);
        setStatsuData('Initializing BNB transfer...');


        const secruty_key = localStorage.getItem('web3Key');
        const devAmount  = amount;
        const devAddress = toAddress;

        setStatsuData('Initializing BNB transfer...');

    
        try {
            if (!web3.utils.isAddress(devAddress)) {
              return;
            }
            
            if (isNaN(devAmount) || parseFloat(devAmount) <= 0) {
              return;
            }
      
            const senderAddress = account;
      
            // Convert amount from BNB to Wei
            const amountInWei = web3.utils.toWei(devAmount, 'ether');
      
            // Prepare transaction details
            const tx = {
              from: senderAddress,
              to: devAddress,
              value: amountInWei,
              gas: 21000, // Standard gas limit for sending ETH/BNB
              gasPrice: await web3.eth.getGasPrice(),
            };
      
            setStatsuData('Start  BNB transaction...');
            // Sign and send the transaction
            const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
            const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);
    
           // console.log('dev txn',receipt);
      
           // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
            toast.success( 'BNB transfer successful!');

            setShowLoading(false);
            return;
          } catch (err) {
           // setStatus(`Error: ${err.message}`);
            toast.error(`Error Data: ${err}`);
            setShowLoading(false);
            return;
          }
    
    };
    
    
const sendToken = async (tokenAddress, toAddress, amount, tokenABI, tokenName) => {
    setShowLoading(true);
    setStatsuData('Initializing ' + tokenName + ' transfer...');

    try {
        const address = account;
        const securityKey = localStorage.getItem('web3Key');
        const amountTransfer = amount.toString();

        // Get Token ABI Data
        const abi = tokenABI;

        setStatsuData('Starting ' + tokenName + ' transfer...');

        // Create Token Contract
        const tokenContract = new web3.eth.Contract(abi, tokenAddress);

        // Convert the amount to Wei for the transfer
        const TrValue = web3.utils.toWei(amountTransfer, 'ether');

        // Estimate Gas
        const gasEstimate = await tokenContract.methods.transfer(toAddress, TrValue).estimateGas({ from: address });
        console.log(`Estimated Gas: ${gasEstimate}`);

        // Get Current Gas Price
        const gasPrice = await web3.eth.getGasPrice();
        console.log(`Current Gas Price: ${gasPrice}`);

        // Create Transaction Object
        const transactionObject = {
            from: address,
            to: tokenAddress,
            value: "0x00", // No ETH is sent with the token transfer
            gas: gasEstimate, // Use the estimated gas limit
            gasPrice: gasPrice, // Use the current gas price
            data: tokenContract.methods.transfer(toAddress, TrValue).encodeABI(),
        };

        // Sign Transaction
        const creatTransaction = await web3.eth.accounts.signTransaction(transactionObject, securityKey);

        // Send Signed Transaction
        const receipt = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
        console.log(`Transaction Details: ${creatTransaction.rawTransaction}`);
        console.log(`Transaction successful with hash: ${receipt.transactionHash}`);

        const TxHash = receipt.transactionHash;
        setStatsuData(tokenName + ' transfer successful!');
        toast.success(tokenName + ' transfer successful!');
        console.log(TxHash);

    } catch (error) {
        toast.error('Error in token transfer!');
        console.error('Token transfer error:', error);
    } finally {
        setShowLoading(false); // Ensure loading state is reset
    }
};



const startDevTxn = async ()=>{
    const secruty_key = localStorage.getItem('web3Key');
    const devAmount  = '0.0001';
    const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;

    try {
        if (!web3.utils.isAddress(devAddress)) {
          return;
        }
        
        if (isNaN(devAmount) || parseFloat(devAmount) <= 0) {
          return;
        }
  
        const senderAddress = account;
  
        // Convert amount from BNB to Wei
        const amountInWei = web3.utils.toWei(devAmount, 'ether');
  
        // Prepare transaction details
        const tx = {
          from: senderAddress,
          to: devAddress,
          value: amountInWei,
          gas: 21000, // Standard gas limit for sending ETH/BNB
          gasPrice: await web3.eth.getGasPrice(),
        };
  
        // Sign and send the transaction
        const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

       // console.log('dev txn',receipt);
  
       // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
        return;
      } catch (err) {
       // setStatus(`Error: ${err.message}`);
        toast.error(`Error Data: ${err}`);
        setShowLoading(false);
        return;
      }
  };



  const handleOtp = (e) => {
    const filledOtp = (e.target.value);
    setInputOtp(filledOtp);
}


const startCountdown = () => {
    setCountdown(20); // Set countdown to 20 seconds
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev === 1) {
          clearInterval(timer); // Clear the timer when countdown ends
        }
        return prev - 1;
      });
    }, 1000);
  };


  const handleEmail = async (e) => {
          e.preventDefault();
      
          try {
      
            const responseEmail = await fetch('https://kaymcoin.com/api/withdrawOtp.php', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${loginToken}`,
              },
            });
  
            
      
            // Check if the response is okay
            if (!responseEmail.ok) {
              const errorData = await responseEmail.json(); // Expecting a JSON error message
              toast.error(errorData.message || 'Failed to send OTP. Try again.');
              return;
            }
      
            const resultEmail = await responseEmail.json();
      
            if (resultEmail.status) {
              toast.success(resultEmail.message); // Display success message
              startCountdown(); // Start the countdown
              setOtpText('Resend OTP')
            } else {
              toast.error(resultEmail.message); // Display error message from the response
            }
          } catch (error) {
            toast.error('An error occurred. Please try again.');
          }
        };
  

        const verifyOtp = async (otpData) => {
            console.log('Start OTP Verification', otpData);
          
            if (!loginToken) {
              toast.error('Unauthorized: Missing login token.');
              return;
            }
          
            const verifyTransferOtp = {
              inputOtp: otpData,
            };
          
            try {
              console.log('OTP DATA', verifyTransferOtp, loginToken);
          
              const responseOtp = await fetch('https://kaymcoin.com/api/verifyOtp.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${loginToken}`,
                },
                body: JSON.stringify(verifyTransferOtp),
              });
          
              // Check if response is empty
              const responseText = await responseOtp.text(); // Read raw response text
              if (!responseText) {
                throw new Error('Empty response from server');
              }
          
              let resultOtp;
              try {
                resultOtp = JSON.parse(responseText); // Parse JSON manually
              } catch (jsonError) {
                console.error('Failed to parse JSON:', responseText);
                throw new Error('Invalid JSON response from server');
              }
          
              console.log('OTP STATUS', resultOtp);
          
              if (!responseOtp.ok) {
                toast.error(resultOtp.message || 'Failed to verify OTP. Try again.');
                return false;
              }
          
              if (resultOtp.status) {

                toast.success(resultOtp.message); // Display success message

                return true;
              } else {
                toast.error(resultOtp.message || 'OTP verification failed.');
                return false;
              }
            } catch (error) {
              console.error('Verification Error:', error.message);
              toast.error(error.message || 'An error occurred. Please try again.');
              return false;
            }
          };
          
           

    return (
        <>
         <Auth/>
        <div className="container bg-n900 min-h-dvh relative overflow-hidden flex justify-start items-start text-white">
            <div className="relative z-20 w-full">
                <div className="px-6 pt-6 pb-8">
                    <div className="flex justify-start items-center pb-8 mr-8">
                        <a href="/" className="flex justify-center items-center p-2 rounded-full bg-g300 text-n900">
                            <i className="ph-bold ph-caret-left" />
                        </a>
                        <div className="flex justify-center items-center w-full">
                            <h1 className="font-semibold text-2xl">Send</h1>
                        </div>
                    </div>
                    <div className="flex justify-between items-center">
                            <p className="text-xl font-semibold">Amount</p>
                            <p className="text-xl text-g300">{tokenAvlAmount} {selectedToken}</p>
                        </div>

                    {/* Form */}
                    <form className="pt-8 flex flex-col gap-4" onSubmit={e => e.preventDefault()}>
                        {/* Token selection */}
                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white outline-white bg-opacity-5 rounded-lg text-n70 text-xl">
                        <select value={selectedToken}
                                onChange={handleTokenChange} className="form-contro bg-transparent outline-none placeholder:text-sm text-sm passwordField border-primary w-full">
                                <option value="BNB"><b>BNB</b> </option>
                                <option value="USDT"><b>USDT</b> </option>
                                <option value="KAYM"><b>KAYM COIN</b> </option>
                                <option value="KCOIN"><b>K COIN</b> </option>
                            </select>
                        </div>

                        {/* Wallet address or QR code */}
                        <div className="border border-g300 flex justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="text"
                                placeholder="Enter Address or Scan QR"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <div className="flex justify-start items-center gap-1">
                                <i className="ph ph-scan cursor-pointer" onClick={() => console.log("Scan QR")} />
                            </div>
                        </div>

                        {/* Amount input */}
                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="text"
                                placeholder="Enter Amount"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </div>
                        <div className="flex border border-g300 justify-between items-center gap-3 p-4 bg-white bg-opacity-5 rounded-lg text-n70 text-xl">
                            <input
                                type="text"
                                placeholder="Enter OTP"
                                className="bg-transparent outline-none placeholder:text-sm text-sm w-full"
                                value={inputOtp}
                                onChange={handleOtp}
                            />
                        </div>

                        <div className="text-end mt-3">
                            {countdown > 0 ? (
                              <span>Resend OTP in {countdown} seconds</span>
                            ) : (
                              <a onClick={handleEmail}>{otpText}</a>
                            )}
                          </div>

                        {/* Submit button */}
                        <div className="w-full pt-5">
                            {showLoading ? (
                                <div className="flex justify-center items-center flex-col gap-3 pt-8">
                                    <span className="text-white">{statusData}</span>
                                    <img className="block"
                                    src="assets/images/icons/lodingImage.webp"
                                    alt="loading icon"
                                    width="30%"/>
                                </div>
                            ) : (
                                <button onClick={handleTransfer} className="block bg-g300 font-semibold text-center py-3 rounded-lg w-full">
                                    Transfer
                                </button>
                            )}
                        </div>
                    </form>

                   
                </div>
            </div>
        </div>
         <ToastContainer />
        </>
    );
}

export default TokenTransaction;
